/* import __COLOCATED_TEMPLATE__ from './recent-orders.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();